var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{attrs:{"pill":"","variant":"light"}},[(_vm.label)?_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('font-awesome-icon',{staticClass:"text-warning",attrs:{"icon":"fa-duotone fa-coin","size":"lg"}}),_vm._v(" "+_vm._s(_vm.amount)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }